import React from 'react';

// Material UI Components
import { Drawer as DrawerComponent, List, ListItem, ListItemText, Typography, Box, Button, IconButton, ListItemSecondaryAction, Paper} from '@material-ui/core';

// Icons
import DeleteIcon from '@material-ui/icons/Delete';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import AddIcon from '@material-ui/icons/Add';

export default function Drawer( {notes, drawerOpen, toggleDrawer, onClickClearNotes, onClickDeleteNote, handleToggleLock, handleCheckNote} ){           
    return (
        <DrawerComponent open={drawerOpen} onClick={(toggleDrawer)()}>
            <Box
                role="presentation"
                m={2}
                style={{width: "250px"}}
                >
                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                    <Typography variant="h6">My Notes</Typography>
                    <Button 
                        aria-label="Clear" 
                        color="secondary"
                        variant="outlined"
                        onClick={onClickClearNotes}
                        disabled={(notes.length > 0 ? false : true)}>
                        Clear
                    </Button>
                </div>
                <List>
                    <Box mt={1.5} mb={1}>
                        <Paper variant="outlined">
                            <ListItem button onClick={() => handleCheckNote("New")}>
                                <ListItemText primary={"New Note"} />
                                <ListItemSecondaryAction>
                                    <IconButton edge="end" aria-label="New Note" onClick={() => handleCheckNote("New")} color="inherit">
                                        <AddIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        </Paper>
                    </Box>
                    {
                        notes.map(note => {
                            return(
                                <ListItem key={note.id} divider button onClick={() => handleCheckNote(note)}>
                                    <ListItemText primary={note.titleDrawer} secondary={note.date} />
                                    <ListItemSecondaryAction>
                                        <IconButton edge="start" aria-label={note.locked === true ? "Locked Note" : "Unlocked Note"} onClick={note.locked === true ? () => handleToggleLock(note, "turnOff") : () => handleToggleLock(note, "turnOn")}>
                                            {
                                                note.locked === true ? <LockIcon /> : <LockOpenIcon />
                                            }
                                        </IconButton>
                                        <IconButton edge="end" aria-label="Delete Note" onClick={() => onClickDeleteNote(note.id)} color="secondary">
                                            <DeleteIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            );
                        })
                    }
                </List>
            </Box>
        </DrawerComponent>
    )
}
